// src/helpers/Queries.ts
var Queries = class {
  static isCacheEnabledInQuery() {
    if (typeof window === "undefined")
      return false;
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    return params.get("cache_enabled") === "true";
  }
  static isClearCacheInQuery() {
    if (typeof window === "undefined")
      return false;
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    return params.get("clear_cache") === "true";
  }
  static isDebuggerInQuery() {
    if (typeof window === "undefined")
      return false;
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    return params.get("v") === "debug";
  }
  static checkForCustomExtensionInQuery() {
    if (typeof window === "undefined")
      return ".gltf";
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    const extension = params.get("ext");
    return extension ? "_" + extension + ".glb" : ".gltf";
  }
};

export {
  Queries
};
